import { type Page } from './constants';
import createErrors from '../createErrors';

export type Component = 'InStoreAutoshipRedirect';

/**
 * Errors related to the In Store Autoship Redirect page
 */
export const Errors = createErrors<Page, Component>('InStoreAutoshipRedirect')({
    InStoreAutoshipRedirect: {
        Page: {
            severity: 'HIGH',
            message: 'Failed to get enrollment profile data',
        },
    },
});
